module.exports = __webpack_public_path__ + "static/media/movimientos.589eec22.svg";